var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "page_Container" } }, [
    _c("div", { attrs: { id: "membercenter" } }, [
      _c(
        "div",
        { attrs: { id: "main-container" } },
        [
          _c("div", { staticClass: "message" }, [
            _vm._v("电子发票PDF元件，将以邮件方式发送至指定邮箱。")
          ]),
          _vm._v(" "),
          _c(
            "van-cell-group",
            [
              _c("van-field", {
                attrs: { placeholder: "请输入邮箱地址", label: "邮箱地址" },
                model: {
                  value: _vm.email,
                  callback: function($$v) {
                    _vm.email = $$v
                  },
                  expression: "email"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btns" },
            [
              _c(
                "van-button",
                {
                  attrs: { round: "", type: "primary", size: "large" },
                  on: { click: _vm.sendEmail }
                },
                [_vm._v("发送")]
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }